import React, { Component } from "react";
import Tabs from "../../../common/tabs/Tabs.js";
import UserCalendar from "./_userCalendar.js";
import CompanyCalendar from "./_companyCalendar.js";

import "./Calendar.css";

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "MY CALENDAR"
    };
  }

  /**
   * Click handler for undo button
   */
  onUndoClick = () => {
    // delete events with new prop from state
    this.setState({
      events: this.state.events.filter(e => e.updated),
      updated: false
    });
  };

  /**
   * Click handler for tab buttons
   */
  onTabClick = tabName => {
    this.setState({ selectedTab: tabName });
  };

  render() {
    return (
      <div className="calendar-container">
        {this.state.showInputModal && this._commentInput()}
        <div className="tabs-container">
          <Tabs
            onTabClick={this.onTabClick}
            selectedTab={this.state.selectedTab}
            tabs={["MY CALENDAR", "COMPANY CALENDAR"]}
          />
        </div>
        {this.state.selectedTab === "MY CALENDAR" ? (
          <UserCalendar match={this.props.match} />
        ) : (
          <CompanyCalendar match={this.props.match} />
        )}
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/main/calendar/Calendar.js